import { render, staticRenderFns } from "./DetailSearch.vue?vue&type=template&id=adfdf712&"
import script from "./DetailSearch.vue?vue&type=script&lang=js&"
export * from "./DetailSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports